import React, { useEffect, useState } from 'react'
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import AddIcon from '@mui/icons-material/Add';
import { blue} from '@mui/material/colors';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import { Autocomplete, DialogContent, Divider, IconButton, Paper, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { collection, query, onSnapshot, doc, getDoc, where, updateDoc, } from "firebase/firestore"
import { app, database} from '../../../firebaseConfig'
function ListServiceChu({ onClose, open, data }) {
    const [serviceChus, setService_chus] = useState([])
    const [serviceChu, setServiceChu] = useState(null)
    const chuId = data.id
    useEffect(() => {
        const q = query(collection(database, 'service_chu'), where("chu_id", "==", chuId))
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const servicesData = querySnapshot.docs.map(async (serviceDoc) => {
                const serviceData = serviceDoc.data()
                const serviceId = serviceData.service_id
                const serviceDocRef = doc(database, 'service', serviceId);
                const serviceDocSnapshot = await getDoc(serviceDocRef);
                const nom = serviceDocSnapshot.data().nom_service
                return {
                    id: serviceDoc.id,
                    service_id: serviceId,
                    chu_id: chuId,
                    label: nom,
                    status: serviceDoc.data().status
                }
            })
            Promise.all(servicesData).then((modifiedServices) => {
                setService_chus(modifiedServices);
            });
        })
        return () => unsubscribe();
    }, [])
    const handleUpdate = async (e) => {
        e.preventDefault()
        const serviceChuDocRef = doc(database, 'service_chu', serviceChu.id)
        try {
            await updateDoc(serviceChuDocRef, {
                chu_id: serviceChu.chu_id,
                service_id: serviceChu.service_id,
                status: true
            })
        } catch (err) {
            alert(err)
        }
    }
    const handleDelete = async (service) => {
        const serviceChuDocRef = doc(database, 'service_chu', service.id)
        try {
            await updateDoc(serviceChuDocRef, {
                chu_id: service.chu_id,
                service_id: service.service_id,
                status: false
            })
        } catch (err) {
            alert(err)
        }
    }
    return (
        <Dialog onClose={onClose} open={open} >
            <DialogTitle sx={{ m: 0, p: 2 }}>Liste des services</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Autocomplete
                        includeInputInList
                        id="combo-box-demo"
                        options={serviceChus.filter(service => !service.status && service)}
                        sx={{ ml: 1, flex: 1, width: 300 }}
                        onChange={(event, values) => {
                            setServiceChu(values)
                        }}
                        renderInput={(params) => <TextField {...params} label="Choisir une service" variant="standard" />}
                    />
                    <IconButton sx={{ p: '10px', bgcolor: blue[100], color: blue[600] }} aria-label="directions" onClick={handleUpdate}>
                        <AddIcon />
                    </IconButton>
                </div>
                <div>
                    <List sx={{ pt: 2 }} style={{ minWidth: 500 }}>
                        {serviceChus.map((service) => service.status && (
                            <ListItem
                                key={service.id}
                                secondaryAction={
                                    <IconButton edge="end" aria-label="delete" onClick={() => {
                                        handleDelete(service)
                                    }}>
                                        <CloseIcon color='error' />
                                    </IconButton>
                                }
                            >
                                <ListItemAvatar>
                                    <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                                        <MedicalServicesIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={service.label}
                                />
                            </ListItem>
                        ))}

                    </List>
                </div>
            </DialogContent>
        </Dialog>
    )
}
export default ListServiceChu